import { render, staticRenderFns } from "./detail-potential-breach.vue?vue&type=template&id=67a34d2a&scoped=true&"
import script from "./detail-potential-breach.vue?vue&type=script&lang=js&"
export * from "./detail-potential-breach.vue?vue&type=script&lang=js&"
import style0 from "./detail-potential-breach.vue?vue&type=style&index=0&id=67a34d2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a34d2a",
  null
  
)

export default component.exports